import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Container, Body } from './styles'

import Loading from '../../components/Loading'
import Quotes from '../../components/Quotes'
import Header from '../../components/Header'
import Button from '../../components/Buttons'
import { ResultsDesktop, ResultsMobile } from '../../components/Results'

import headline from './img/headline.png'
import clientLogos from './img/client-logos.png'
import clientLogosMobile from './img/client-logos-mobile.png'
import product3DDesktop from './img/product-3d-desktop.gif'
import productAR from './img/product-ar.gif'
import customizer from './img/customizer.png'
import liveScenes from './img/live-scenes.png'
import Footer from '../../components/Footer'

const viewerUrl =
  'https://viewer.r2u.io/?customerId=5e9736c3ecaf5900072fa278&sku=208743'
const arUrl =
  'https://viewer.r2u.io/?customerId=5dd82edbc79e040008e8f8b9&sku=38021'
const customizerUrl = 'https://customizer.r2u.io'
const liveScenesUrl = 'https://live-scenes.r2u.io'

const LandingPage: React.FC = () => {
  const { t, ready } = useTranslation(['landing-page'])
  const productsRef = useRef(null)
  const [isContactOpen, setIsContactOpen] = useState(false)

  return (
    <Loading isLoading={!ready}>
      <Container>
        <Header
          refs={{ productsRef }}
          isContactOpen={isContactOpen}
          setIsContactOpen={setIsContactOpen}
        />
        <Body>
          <section className="headline-section">
            <div className="left">
              <h1>{t('headline.title')}</h1>
              <span>{t('headline.description')}</span>
              <Button onClick={() => setIsContactOpen(true)} type="primary">
                {t('headline.cta')}
              </Button>
            </div>
            <div>
              <img src={headline} alt="Headline" />
            </div>
          </section>
          <section className="client-logos">
            <img src={clientLogos} alt="Client Logos" />
          </section>
          <section className="client-logos-mobile">
            <img src={clientLogosMobile} alt="Client Logos" />
          </section>
          <section className="products-section">
            <div ref={productsRef} className="heading">
              <h1>{t('products.details')}</h1>
              <span className="description">{t('products.description')}</span>
            </div>
            <div>
              <div className="products products-3d-desktop">
                <div className="left">
                  <h3>{t('products-3d-desktop.title')}</h3>
                  <p>{t('products-3d-desktop.description')}</p>
                  <ResultsDesktop />
                  <Button
                    onClick={() => {
                      window.open(viewerUrl)
                    }}
                    type="primary"
                  >
                    {t('products-3d-desktop.cta')}
                  </Button>
                </div>
                <div className="img-container">
                  <img src={product3DDesktop} alt="3D Desktop" />
                </div>
              </div>
              <div className="products products-ar">
                <div className="left">
                  <h3>{t('products-ar.title')}</h3>
                  <p>{t('products-ar.description')}</p>
                  <ResultsMobile />
                  <Button
                    onClick={() => {
                      window.open(arUrl)
                    }}
                    type="primary"
                  >
                    {t('products-ar.cta')}
                  </Button>
                </div>
                <div className="img-container">
                  <img src={productAR} alt="Augmented Reality" />
                </div>
              </div>
              <div className="products products-new">
                <div className="left">
                  <h3>{t('products-customizer.title')}</h3>
                  <p>{t('products-customizer.description')}</p>
                  <Button
                    onClick={() => {
                      window.open(customizerUrl)
                    }}
                    type="primary"
                  >
                    {t('products-customizer.cta')}
                  </Button>
                  <div className="img-container">
                    <img src={customizer} alt="Customizer" />
                  </div>
                </div>
                <div>
                  <h3>{t('products-live-scenes.title')}</h3>
                  <p>{t('products-live-scenes.description')}</p>
                  <Button
                    onClick={() => {
                      window.open(liveScenesUrl)
                    }}
                    type="primary"
                  >
                    {t('products-live-scenes.cta')}
                  </Button>
                  <div className="img-container">
                    <img src={liveScenes} alt="Live Scenes" />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Quotes />
          <section className="bottomline-section">
            <div className="title">
              <h2>{t('bottomline.title')}</h2>
              <h1>{t('bottomline.title')}</h1>
              <span>{t('bottomline.description')}</span>
            </div>
            <hr />
          </section>
        </Body>
        <Footer />
      </Container>
    </Loading>
  )
}
export default LandingPage
